import { ColDef } from 'ag-grid-community';

export const CustomerTableColumnDef: ColDef[] = [
  {
    // ID
    headerName: '_ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // ID
    headerName: 'ID',
    field: 'contact_id',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    hide: false,
  },
  {
    // Contact Type
    headerName: 'Contact Type',
    field: 'contact_type',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {
    // Display Name
    headerName: 'Display Name',
    field: 'contact.display_name',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
  {
    // Email
    headerName: 'Email',
    field: 'contact.email',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
  {
    // Phone Number
    headerName: 'Phone Number',
    field: 'contact.phone_number',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
  {
    // Tax Option
    headerName: 'Tax Option',
    field: 'tax_option.name',
    resizable: true,
    filter: 'agTextColumnFilter',
    width:200,
  },
  {
    // Memo 
    headerName: 'Memo',
    field: 'memo',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  }
];